<mat-card *ngIf="!hideOwnershipCombo">
  <h2>
    {{ (interviniente ? 'request.directDebitTitle.participant' : 'request.directDebitTitle') | translate }}
    {{ numInterviniente }}
  </h2>
  <form [formGroup]="directDebitForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="100" fxFlex.gt-sm="50">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="ownershipCombo"
          [id]="'ownershipDirectDebit'"
          [dataInput]="ownershipList"
          [placeholder]="'request.ownershipLabel'"
          [isRequired]="true"
          [showErrors]="directDebitForm?.controls?.ownershipCombo?.errors"
        ></scf-custom-select-search>
      </div>

      <div fxFlex="0" fxFlex.gt-sm="50"></div>

      <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!interviniente">
        <mat-form-field fxFlex="100" appearance="outline" floatLabel="always">
          <mat-label translate>request.bankAccount</mat-label>
          <span matPrefix>ES &nbsp;</span>
          <input
            id="creditAccountDirectDebit"
            #numberCreditAccount
            [inputMask]="licenseInputMask"
            formControlName="numberCreditAccount"
            placeholder="IBAN"
            matInput
            type="text"
            (keyup)="updateIban($event.target.value)"
            autocomplete="off"
          />
          <mat-error *ngIf="directDebitForm.controls.numberCreditAccount.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error
            *ngIf="
              directDebitForm.controls.numberCreditAccount.invalid &&
              !directDebitForm.controls.numberCreditAccount.hasError('required')
            "
            translate
          >
            field.error.numberAccount
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>
